import React, { useState, useEffect } from 'react';
import { Stepper, Step, StepLabel, StepContent } from '@material-ui/core';
import styles from './UnitHistory.module.scss';
import dayjs from 'dayjs';
import {
	getSingleElevationHistory,
	getMultipleElevationsHistory,
} from '../../../api/Siteplan/getHistory.api';

const stepIcon = () => {
	return <div className={styles.circle} />;
};

const UnitHistory = (props) => {
	const { buildingId, elevationId } = props;
	const [unitHistory, setUnitHistory] = useState([]);

	useEffect(() => {
		if (elevationId) {
			getSingleElevationHistory(buildingId, elevationId, (returned) => {
				setUnitHistory(returned);
			});
		} else {
			getMultipleElevationsHistory(buildingId, (returned) => {
				setUnitHistory(returned);
			});
		}
	}, [buildingId, elevationId]);

	const getPriceChange = (newValue, oldValue) => {
		let diff = Number(newValue) - Number(oldValue);
		diff = +(Math.round(diff + 'e+2') + 'e-2');
		if (diff > 0) {
			return `Increased by \$${Math.abs(diff)}`;
		} else {
			return `Decreased by \$${Math.abs(diff)}`;
		}
	};

	return (
		<div className={styles.unit_history}>
			<h2 className={styles.unit_history_title}>Unit History</h2>
			<Stepper
				activeStep={-1}
				orientation='vertical'
				className={styles.stepper}
			>
				{unitHistory.map((item, index) => (
					<Step key={index}>
						<StepLabel StepIconComponent={stepIcon}>
							<div>
								<span className={styles.elevation}>
									{item.buildingId +
										' ' +
										item.elevationId +
										' | '}
								</span>
								<span className={styles.price}>
									{'$' + item.newValue}
								</span>
							</div>
							<div className={styles.price_change}>
								{getPriceChange(item.newValue, item.oldValue)}
							</div>
							<div className={styles.time}>
								{dayjs(item.timestamp).format('ddd DD MMM')} |
								By {item.alteredByName}
							</div>
						</StepLabel>
					</Step>
				))}
			</Stepper>
		</div>
	);
};

export default UnitHistory;
